import React from "react";
import classNames from "classnames";
import withStyles from "react-jss";

const styles = (theme) => {
	return {
		root: {
			display: "flex",
			alignItems: "center",
		},
		text: {
			fontFamily: theme.fonts.medium,
			fontSize: "16px",
			lineHeight: 1,
		},
		isAccept: {
			"& $text": {
				color: theme.palette.colors.cloudyBlue,
			},
			"& $icon": {
				"& span": {
					color: theme.palette.colors.cloudyBlue,
				},
			},
		},
		icon: {
			marginRight: "8px",
			"& span": {
				fontSize: "18px",
			},
		},

		isDecline: {
			"& $text": {
				color: theme.palette.colors.cloudyBlue,
			},
			"& $icon": {
				"& span": {
					color: theme.palette.colors.cloudyBlue,
				},
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			root: {},
			text: {
				fontSize: "14px",
			},
		},
	};
};

const ReviewStatus = (props) => {
	let classes = props.classes;
	let texts = props.texts;
	let isCounted = props.code === "counted";
	let isChecked = props.code === "checked";
	return (
		<div
			className={classNames(classes.root, {
				[classes.isAccept]: isCounted,
				[classes.isDecline]: isChecked,
			})}
		>
			<span className={classes.icon}>
				{isCounted && <span className={"icon24 icon-check"} />}
				{isChecked && <span className={"icon24 icon-close"} />}
			</span>
			<span className={classes.text}>
				{isCounted && texts.REVIEW_IS_ACCEPT}
				{isChecked && texts.REVIEW_IS_DECLINE}
			</span>
		</div>
	);
};

ReviewStatus.defaultProps = {
	code: "",
};
export default withStyles(styles)(ReviewStatus);

export { ReviewStatus as __ReviewStatus };
